import { useEffect, useRef } from 'react';
import { useAuthFlow } from './useAuthFlow';
import { useSelector } from 'react-redux';
import { userSelector } from '../../redux/user/selector';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { PrivateRoutes } from '../../routes/navigation';
import { authStateSelector } from '../../redux/auth/selector';
import { useIonRouter } from '@ionic/react';

export function useNeedUpdatePersonalData() {
  const { authUser } = useAuthFlow();
  const isRedirectedRef = useRef(false);
  const history = useHistory();
  const user = useSelector(userSelector);
  const authData = useSelector(authStateSelector);
  const location = useLocation();
  const navigation = useIonRouter();

  useEffect(() => {
    if (!authUser) return;

    const path = location?.pathname ?? navigation.routeInfo.pathname ?? '';

    if (
      path === '/' ||
      path.includes('on-boarding') ||
      path.includes('auth') ||
      path.includes('flow') ||
      navigation.routeInfo.pathname.includes('flow')
    ) {
      return;
    }

    if (!user?.id || !user?.email) return;
    if (user?.dob && user?.country) return;
    if (isRedirectedRef.current) return;
    if (authData.isNeedAdditionalData) {
      history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_FIRST_NAME);
    } else {
      history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA);
    }
    isRedirectedRef.current = true;
  }, [user?.id, user?.dob, user?.country, history, authData, location?.pathname]);
}
